(() => {
  'use strict';

  /* ==================================================
     Premiumウェイトリスト モーダル
  ================================================== */

  const SCROLL_STORAGE_KEY = 'premiumWaitlistScrollY';
  const SUCCESS_SHOWN_KEY = 'premiumWaitlistSuccessShown';

  let lastFocusedElement = null;

  const getModal = () => {
    return document.getElementById('PremiumWaitlistModal');
  };

  const openModal = () => {
    const modal = getModal();

    if (!modal) {
      console.error('PremiumWaitlistModalが見つかりません。');
      return;
    }

    lastFocusedElement = document.activeElement;

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ps-premium-modal-open');

    const emailInput = modal.querySelector('input[type="email"]');
    const closeButton = modal.querySelector('[data-premium-modal-close]');

    setTimeout(() => {
      if (emailInput) {
        emailInput.focus();
      } else if (closeButton) {
        closeButton.focus();
      }
    }, 100);
  };

  const closeModal = () => {
    const modal = getModal();

    if (!modal) return;

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ps-premium-modal-open');

    if (
      lastFocusedElement &&
      typeof lastFocusedElement.focus === 'function'
    ) {
      lastFocusedElement.focus();
    }

    lastFocusedElement = null;
  };

  /* Shopifyフォーム送信前の位置を保存 */
  document.addEventListener('submit', (event) => {
    const form = event.target;

    if (!(form instanceof HTMLFormElement)) return;
    if (form.id !== 'PremiumWaitlistForm') return;

    sessionStorage.setItem(
      SCROLL_STORAGE_KEY,
      String(window.scrollY)
    );

    /*
      新たに登録するときは、
      前回の「完了画面表示済み」記録を解除
    */
    sessionStorage.removeItem(SUCCESS_SHOWN_KEY);
  });

  /* モーダルを開く・閉じる */
  document.addEventListener('click', (event) => {
    const target = event.target;

    if (!(target instanceof Element)) return;

    const openButton = target.closest(
      '[data-premium-modal-open]'
    );

    const closeButton = target.closest(
      '[data-premium-modal-close]'
    );

    if (openButton) {
      event.preventDefault();
      openModal();
      return;
    }

    if (closeButton) {
      event.preventDefault();
      closeModal();
    }
  });

  /* Escapeキーで閉じる */
  document.addEventListener('keydown', (event) => {
    const modal = getModal();

    if (
      event.key === 'Escape' &&
      modal &&
      modal.classList.contains('is-open')
    ) {
      closeModal();
    }
  });

  /* 保存していたスクロール位置へ戻す */
  const restoreScrollPosition = () => {
    const savedScrollY = sessionStorage.getItem(
      SCROLL_STORAGE_KEY
    );

    if (savedScrollY === null) return false;

    const scrollY = Number(savedScrollY);

    sessionStorage.removeItem(SCROLL_STORAGE_KEY);

    if (!Number.isFinite(scrollY)) return false;

    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    /*
      Shopifyやブラウザ側の自動スクロールより後にも
      元の位置を再適用する
    */
    window.scrollTo(0, scrollY);

    requestAnimationFrame(() => {
      window.scrollTo(0, scrollY);

      requestAnimationFrame(() => {
        window.scrollTo(0, scrollY);
      });
    });

    setTimeout(() => {
      window.scrollTo(0, scrollY);
    }, 100);

    setTimeout(() => {
      window.scrollTo(0, scrollY);

      if ('scrollRestoration' in history) {
        history.scrollRestoration = 'auto';
      }
    }, 300);

    return true;
  };

  /* ShopifyがURLへ追加した完了情報を削除 */
  const cleanFormResultUrl = () => {
    const url = new URL(window.location.href);

    url.searchParams.delete('contact_posted');
    url.searchParams.delete('customer_posted');

    if (
      url.hash.includes('PremiumWaitlistForm') ||
      url.hash.includes('contact_form')
    ) {
      url.hash = '';
    }

    const cleanUrl =
      `${url.pathname}${url.search}${url.hash}`;

    window.history.replaceState(
      {},
      document.title,
      cleanUrl
    );
  };

  /* 登録完了・エラー時の処理 */
  const checkWaitlistFormResult = () => {
    const modal = getModal();

    if (!modal) return;

    const successMessage = modal.querySelector(
      '[data-waitlist-success]'
    );

    const errorMessage = modal.querySelector(
      '.ps-premium-modal__error'
    );

    if (successMessage) {
      cleanFormResultUrl();

      const alreadyShown =
        sessionStorage.getItem(SUCCESS_SHOWN_KEY) === 'true';

      /*
        ページ更新のたびに登録完了モーダルが
        再表示されるのを防ぐ
      */
      if (alreadyShown) return;

      sessionStorage.setItem(
        SUCCESS_SHOWN_KEY,
        'true'
      );

      const restored = restoreScrollPosition();

      setTimeout(() => {
        openModal();
      }, restored ? 120 : 0);

      return;
    }

    if (errorMessage) {
      cleanFormResultUrl();

      const restored = restoreScrollPosition();

      setTimeout(() => {
        openModal();
      }, restored ? 120 : 0);
    }
  };


  /* ==================================================
     カリキュラム 横ドラッグスクロール
  ================================================== */

  const initializeCurriculumSliders = () => {
    const sliders = document.querySelectorAll(
      '.ps-curriculum-list'
    );

    sliders.forEach((slider) => {
      /*
        同じスライダーへイベントを
        二重登録しないための処理
      */
      if (slider.dataset.dragInitialized === 'true') {
        return;
      }

      slider.dataset.dragInitialized = 'true';

      let isDragging = false;
      let startX = 0;
      let startScrollLeft = 0;

      slider.addEventListener('pointerdown', (event) => {
        /*
          タッチ操作はブラウザ標準の
          スワイプスクロールを利用する
        */
        if (event.pointerType !== 'mouse') return;

        isDragging = true;
        startX = event.clientX;
        startScrollLeft = slider.scrollLeft;

        slider.classList.add('is-dragging');

        slider.setPointerCapture(event.pointerId);
      });

      slider.addEventListener('pointermove', (event) => {
        if (!isDragging) return;

        event.preventDefault();

        const distance = event.clientX - startX;

        slider.scrollLeft =
          startScrollLeft - distance;
      });

      const stopDragging = (event) => {
        if (!isDragging) return;

        isDragging = false;
        slider.classList.remove('is-dragging');

        if (
          slider.hasPointerCapture(event.pointerId)
        ) {
          slider.releasePointerCapture(
            event.pointerId
          );
        }
      };

      slider.addEventListener(
        'pointerup',
        stopDragging
      );

      slider.addEventListener(
        'pointercancel',
        stopDragging
      );

      slider.addEventListener(
        'pointerleave',
        stopDragging
      );
    });
  };


  /* ==================================================
     初期化
  ================================================== */

  const initializeHiroLp = () => {
    checkWaitlistFormResult();
    initializeCurriculumSliders();
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeHiroLp,
      { once: true }
    );
  } else {
    initializeHiroLp();
  }
})();


(() => {
  const modal = document.getElementById('ImageZoomModal');

  if (!modal) return;

  const modalImage = modal.querySelector('.ps-image-zoom__image');
  const closeButtons = modal.querySelectorAll('[data-image-zoom-close]');

  const openModal = (image) => {
    const largeImageSrc =
      image.dataset.zoomSrc ||
      image.currentSrc ||
      image.src;

    modalImage.src = largeImageSrc;
    modalImage.alt = image.alt || '拡大画像';

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');

    document.body.classList.add('ps-image-zoom-open');
  };

  const closeModal = () => {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');

    document.body.classList.remove('ps-image-zoom-open');

    window.setTimeout(() => {
      modalImage.src = '';
      modalImage.alt = '';
    }, 250);
  };

  document.addEventListener('click', (event) => {
    const image = event.target.closest('[data-zoomable]');

    if (!image) return;

    event.preventDefault();
    openModal(image);
  });

  closeButtons.forEach((button) => {
    button.addEventListener('click', closeModal);
  });

  document.addEventListener('keydown', (event) => {
    if (
      event.key === 'Escape' &&
      modal.classList.contains('is-open')
    ) {
      closeModal();
    }
  });
})();